import ActionDialog from "@dashboard/components/ActionDialog";
import { ConfirmButtonTransitionState } from "@dashboard/components/ConfirmButton";
import ControlledCheckbox from "@dashboard/components/ControlledCheckbox";
import { Box } from "@saleor/macaw-ui-next";
import { FormattedMessage, useIntl } from "react-intl";

interface OrderConfirmDialogProps {
  confirmButtonState: ConfirmButtonTransitionState;
  open: boolean;
  orderNumber: string;
  notifyCustomer: boolean;
  onClose: () => void;
  onConfirm: () => void;
  handleNotifyCustomer: (checked: boolean) => void;
}

const OrderConfirmDialog = ({
  confirmButtonState,
  open,
  orderNumber,
  notifyCustomer,
  onClose,
  onConfirm,
  handleNotifyCustomer,
}: OrderConfirmDialogProps) => {
  const intl = useIntl();

  return (
    <ActionDialog
      confirmButtonState={confirmButtonState}
      open={open}
      title={intl.formatMessage({
        id: "D3oBqL",
        defaultMessage: "Confirm Order",
        description: "dialog header",
      })}
      onClose={onClose}
      onConfirm={onConfirm}
      confirmButtonLabel={intl.formatMessage({
        id: "MPJVCA",
        defaultMessage: "Confirm order",
        description: "button",
      })}
    >
      <Box display="grid" gap={4}>
        <FormattedMessage
          id="iQbXMn"
          defaultMessage="You're going to confirm order #{orderNumber}."
          values={{ orderNumber }}
        />
        <ControlledCheckbox
          data-test-id="notify-customer"
          name="notifyCustomer"
          label={intl.formatMessage({
            id: "yLEZpm",
            defaultMessage: "Send order confirmation to the customer",
            description: "finalize draft order, notify customer checkbox",
          })}
          checked={notifyCustomer}
          onChange={event => handleNotifyCustomer(event.target.value)}
        />
      </Box>
    </ActionDialog>
  );
};

OrderConfirmDialog.displayName = "OrderConfirmDialog";
export default OrderConfirmDialog;
